// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-9qRq","dark":"styles_dark__JF7R-","btn":"styles_btn__UNqZb","green":"styles_green__MlrHg"};